import React from 'react';
import { instanceOf } from 'prop-types';
import { Map, List } from 'immutable';
import { Trans, useTranslation } from "react-i18next";

import Button from '@ets-global/b2c-website-ui/Button';

import TimeInfo from './TimeInfo';
import LocationInfo from './LocationInfo';
import PreparationChecklist from './PreparationChecklist';
import { TestTypeProgram } from '../../../../constants';
import { useDataLayer } from '../../../../hooks';
import { extractFilenameFromUrl } from '../../../../helpers/Formatter/StringFormatter';

import './styles.scss';

const SessionDetail = ({ session, candidates }) => {
  const { pushEventPdfDownloaded } = useDataLayer();
  const { t } = useTranslation();
  const hasAMissingPictureCandidates = (candidates) => {
    for (let i = 0; i < candidates.size; i++) {
      if (!candidates.getIn([i, 'pictureUrl'])) {
        return true;
      }
    }

    return false;
  };
  const hasWarning =
    hasAMissingPictureCandidates(candidates) &&
    session.get('testType') &&
    session.get('testType').get('program') === TestTypeProgram.PP &&
    session.get('testType').get('isPhotoRequired');

  return (
    <div className={'account-session-detail'}>
      <div className={'account-session-detail__left'}>
        <TimeInfo
          arrivalTime={session.get('startAt')}
          startTime={session.get('scheduledAt')}
          duration={session.get('duration') || '0'}
          endTime={session.get('endAt')}
          timeZone={session.get('timeZone')}
        />
        <LocationInfo session={session} />
      </div>
      <div className="account-session-detail__right">
        {session.hasIn(['testType', 'candidateHandbook']) && (
          <Button
            to={session.getIn(['testType', 'candidateHandbook', 'url'])}
            className={'button button--full'}
            onClick={() =>
              pushEventPdfDownloaded(
                'candidate handbook',
                extractFilenameFromUrl(session.getIn(['testType', 'candidateHandbook', 'url']))
              )
            }
            aria-label={`${t('account.session.detail.download-candidate-guide')} button`}
          >
            <Trans>account.session.detail.download-candidate-guide</Trans>
          </Button>
        )}

        {hasWarning && (
          <div className="account-session-detail__warning">
            <p>
              <Trans>account.session.detail.message-missing-picture-candidates</Trans>
            </p>
          </div>
        )}

        {session.hasIn(['testType', 'candidatePreparationChecklist']) && (
          <PreparationChecklist
            candidatePreparationChecklist={session.getIn(['testType', 'candidatePreparationChecklist'])}
          />
        )}
      </div>
    </div>
  );
};

SessionDetail.propTypes = {
  session: instanceOf(Map).isRequired,
  candidates: instanceOf(List).isRequired,
};

export default SessionDetail;
